export default __webpack_public_path__ + "static/media/avatars@2x.8cbfd6a4.png";